import * as XLSX from "xlsx";
import Api from "../Api/Api";
import { toast } from "sonner";

export default function useImportExport({
  rows,
  columns,
  fetchData,
  withLoading,
}) {
  const handleExport = () => {
    return withLoading(async () => {
      if (!rows.length) return;

      // get visible columns
      const visibleCols = columns.map((col) => col.field);

      // header
      const header = visibleCols.join(",");

      // rows
      const csvRows = rows.map((row) =>
        visibleCols
          .map((field) => {
            let value = row[field];

            if (value === null || value === undefined) return "";

            // remove commas / format safely
            return `"${String(value).replace(/"/g, '""')}"`;
          })
          .join(","),
      );

      const csv = [header, ...csvRows].join("\n");

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, "Exporting records...");
  };

  const handleImport = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const user = JSON.parse(localStorage.getItem("user"));

    try {
      const data = await file.arrayBuffer();

      const workbook = XLSX.read(data, {
        type: "array",
        raw: true,
      });

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      let jsonData = XLSX.utils.sheet_to_json(sheet, {
        defval: "",
      });

      // 🔥 Normalize keys (IMPORTANT)
      const normalize = (obj) => {
        const newObj = {};

        Object.keys(obj).forEach((key) => {
          const cleanKey = key
            .toLowerCase()
            .trim()
            .replace(/[\s-]/g, "_")
            .replace(/﻿/g, ""); // BOM fix

          newObj[cleanKey] = obj[key];
        });

        return newObj;
      };

      jsonData = jsonData.map(normalize);

      await Api.post("/dashboard/import", {
        rows: jsonData,
        user,
      });

      toast.success("Imported Successfully");
      fetchData();
    } catch (err) {
      console.error(err);
      toast.error("Import Failed");
    }
  };

  const downloadSampleExcel = () => {
    const sample = {};

    columns.forEach((col) => {
      sample[col.field] = "";
    });

    const worksheet = XLSX.utils.json_to_sheet([sample]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");

    XLSX.writeFile(workbook, "sample_import.csv", { bookType: "csv" });
  };

  return {
    handleExport,
    handleImport,
    downloadSampleExcel,
  };
}
